import DOMPurify from 'dompurify';

/**
 * Shared HTML sanitizer for rendered post bodies (admin preview + public page).
 *
 * Same baseline as before (DOMPurify `html` profile, which already permits
 * <img>, <video>, <audio>, <source>), plus a narrow allowance for <iframe>
 * embeds from a fixed list of video hosts. Any iframe whose src host is not on
 * the allowlist is dropped, so this does not open a general iframe hole.
 */
const EMBED_HOSTS = new Set([
  'www.youtube.com',
  'youtube.com',
  'www.youtube-nocookie.com',
  'youtube-nocookie.com',
  'player.vimeo.com',
  'www.loom.com',
  'loom.com',
]);

let hookInstalled = false;
function installHook() {
  if (hookInstalled) return;
  hookInstalled = true;
  DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName !== 'iframe') return;
    const el = node as Element;
    let host = '';
    try {
      host = new URL(el.getAttribute('src') || '', 'https://invalid.example').hostname;
    } catch {
      host = '';
    }
    if (!EMBED_HOSTS.has(host)) {
      el.parentNode?.removeChild(el);
    }
  });
}

export function sanitizeHtml(dirty: string): string {
  installHook();
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'loading',
      'referrerpolicy',
      'title',
    ],
  });
}
